import { createContext, useContext } from "react";
import {
  SubscriptionsPlanOptions,
  SubscriptionsStatusOptions,
} from "@/types/pocketbase-types";

export interface SubscriptionQuota {
  limit: number;
  used: number;
  remaining: number;
  isLimited: boolean;
}

export interface TrialInfo {
  isTrialUser: boolean;
  daysRemaining: number;
  trialExpiresAt: string | null;
  isExpired: boolean;
}

export interface Subscription {
  id: string;
  plan: SubscriptionsPlanOptions;
  status: SubscriptionsStatusOptions;
  nextBillingDate: string;
  articlesQuota: SubscriptionQuota;
  trial?: TrialInfo;
  cancelEndDate?: string;
  cancelAtPeriodEnd?: boolean;
}

interface SubscriptionContextType {
  isLoading: boolean;
  error: Error | null;
  subscription: Subscription | null;
  isFreePlan: boolean;
  isTrialUser: boolean;
  trialInfo: TrialInfo | null;
  hasAvailableQuota: () => boolean;
  getQuotaPercentage: () => number;
  refreshSubscription: () => Promise<void>;
  shouldStartTrial: boolean;
  subscriptionExpired: boolean;
}

export const SubscriptionContext =
  createContext<SubscriptionContextType | null>(null);

export const useSubscription = () => {
  const context = useContext(SubscriptionContext);
  if (!context) {
    throw new Error(
      "useSubscription must be used within a SubscriptionProvider",
    );
  }
  return context;
};
